import { render, staticRenderFns } from "./BindCategory.vue?vue&type=template&id=171396f0&scoped=true"
import script from "./BindCategory.vue?vue&type=script&lang=js"
export * from "./BindCategory.vue?vue&type=script&lang=js"
import style0 from "./BindCategory.vue?vue&type=style&index=0&id=171396f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171396f0",
  null
  
)

export default component.exports